import { ACCEPTED_IMAGE_TYPES } from '../../constants/mediaTypes';
import type { ImageUploadInputProps } from '../../types/fileUpload';
import { BaseUploadInput } from './BaseUploadInput';

export function ImageUploadInput({
  name,
  label,
  description,
  dimensions,
  value = null,
  maxSize,
  onChange,
  onError,
  className,
  placeholderClassName,
  buttonType = 'add',
  buttonClassName,
}: ImageUploadInputProps) {
  return (
    <BaseUploadInput
      name={name}
      label={label}
      description={description}
      dimensions={dimensions}
      value={value}
      onChange={onChange}
      onError={onError}
      className={className}
      placeholderClassName={placeholderClassName}
      buttonType={buttonType}
      buttonClassName={buttonClassName}
      accept={ACCEPTED_IMAGE_TYPES.join(',')}
      acceptedTypes={ACCEPTED_IMAGE_TYPES}
      maxSize={maxSize}
      renderPreview={(url) => (
        <img
          src={url}
          alt={`${label || name} preview`}
          className="block w-full h-full object-cover"
        />
      )}
    />
  );
}
